import { CardContent, Grid, TextField, Typography } from '@mui/material';
import React from 'react';
import { TextInputGradingQuestion } from './GradingQuestionType';
import { GradingQuestionAction } from './GradingQuestionReducer';
import GradingQuestionInput from './GradingQuestionInput';

interface TextInputGradingCardProps {
  data: TextInputGradingQuestion;
  dispatch: React.Dispatch<GradingQuestionAction>;
  isViewMode?: boolean;
}

const TextInputGradingCard: React.FC<TextInputGradingCardProps> = ({
  data,
  dispatch,
  isViewMode = false,
}) => {
  return (
    <CardContent
      sx={{
        marginTop: '24px',
        marginBottom: '12px',
        marginLeft: '48px',
        marginRight: '48px',
        position: 'relative',
      }}
    >
      <Typography variant="h6" sx={{ textAlign: 'left', fontWeight: 'bold' }}>
        {`Question ${data.questionIndex + 1}`}
      </Typography>
      <Grid>
        <Grid item>
          <Typography
            align="left"
            variant="body1"
            gutterBottom
            sx={{
              width: '80%',
            }}
          >
            {data.text}
          </Typography>
          <TextField
            label="Answer text"
            variant="standard"
            sx={{
              display: 'flex',
              width: '80%',
            }}
            multiline
            value={data.answer}
          />
        </Grid>
        <GradingQuestionInput
          dispatch={dispatch}
          maxGrade={data.maxGrade}
          grade={data.grade}
          questionIndex={data.questionIndex}
          gradable={!isViewMode}
        />
      </Grid>
    </CardContent>
  );
};

export default TextInputGradingCard;
